const initTravelTabs = () => {
  const tabBar = document.querySelector('[data-travel-tabs]')
  if (!tabBar) return

  const stickyHeader = document.querySelector('.sticky.top-0')
  const links = Array.from(tabBar.querySelectorAll('[data-tab-link]'))
  if (!links.length) return

  const sections = links
    .map((link) => document.getElementById(link.dataset.tabLink))
    .filter(Boolean)

  const ACTIVE = ['text-[#251974]', 'border-[#251974]']
  const INACTIVE = ['text-[#6b7280]', 'border-transparent']

  // Sticky offset: tab bar sits directly below the (dynamic-height) navbar.
  const applyOffsets = () => {
    const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0
    tabBar.style.top = `${headerHeight}px`

    const totalOffset = headerHeight + tabBar.offsetHeight
    sections.forEach((section) => {
      section.style.scrollMarginTop = `${totalOffset}px`
    })
  }

  applyOffsets()
  window.addEventListener('resize', applyOffsets)

  // Scroll-spy: highlight the tab for the section currently in view.
  const setActive = (id) => {
    links.forEach((link) => {
      const isActive = link.dataset.tabLink === id
      link.classList.remove(...(isActive ? INACTIVE : ACTIVE))
      link.classList.add(...(isActive ? ACTIVE : INACTIVE))
    })
  }

  if (sections.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0]
        if (visible) setActive(visible.target.id)
      },
      { rootMargin: '-40% 0px -55% 0px', threshold: [0, 0.25, 0.5, 1] }
    )
    sections.forEach((section) => observer.observe(section))
  }
}

export default initTravelTabs
